import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import styled, {keyframes} from 'styled-components';
import {wh, fontSize} from '../mixins';
import {sendAnalyticsEvents} from '../analytics/common';
import {EVENTS} from '../analytics/events';
import {selectEventsData} from '../features/events/eventsSlice';


const StyledLayer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    ${wh('100%')};
    padding-top: 30px;
    background-color: rgba(35,35,35,.75);
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;
    transition: .5s;
    opacity: ${({show}) => show ? 1 : 0};
    visibility: ${({show}) => show ? 'visible' : 'hidden'};
`;

const bounce = keyframes`
    0%,100% { transform: translateY(0) }
    50% { transform: translateY(-20px) }
`;

const StyledSVG = styled.svg`
    animation-name: ${bounce};
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    
    &:nth-child(2) {
        animation-delay: 0.05s;
    }
`;

const StyledText = styled.span`
    font-weight: 600;
    ${fontSize(20)};
    line-height: 27px;
    color: #fff;
    margin-top: 16px;
`;

const SwipeUp = () => {
    const eventsData = useSelector(selectEventsData);
    const [eventSent,setEventSent] = useState(false);
    const [show,setShow] = useState(true);

    useEffect(() => setTimeout(() => setShow(false), 4500), []);

    useEffect(() => {
        if (!eventSent) {
            sendAnalyticsEvents(EVENTS.swipeShown, eventsData);
            setEventSent(true);
        }
    }, [eventSent, eventsData]);

    return <StyledLayer show={show}>
        <StyledSVG width="43" height="26" viewBox="0 0 43 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.05128 24.133C-0.12029 22.9615 -0.12029 21.062 1.05128 19.8904L19.7234 1.21828C20.895 0.0467113 22.7945 0.0467103 23.966 1.21828L41.9547 19.2069C43.1262 20.3785 43.1262 22.278 41.9547 23.4495C40.7831 24.6211 38.8836 24.6211 37.712 23.4495L21.8447 7.58224L5.29392 24.133C4.12235 25.3046 2.22286 25.3046 1.05128 24.133Z" fill="white"/>
        </StyledSVG>
        <StyledSVG width="43" height="26" viewBox="0 0 43 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.05128 24.133C-0.12029 22.9615 -0.12029 21.062 1.05128 19.8904L19.7234 1.21828C20.895 0.0467113 22.7945 0.0467103 23.966 1.21828L41.9547 19.2069C43.1262 20.3785 43.1262 22.278 41.9547 23.4495C40.7831 24.6211 38.8836 24.6211 37.712 23.4495L21.8447 7.58224L5.29392 24.133C4.12235 25.3046 2.22286 25.3046 1.05128 24.133Z" fill="white"/>
        </StyledSVG>
        <StyledText>Swipe up</StyledText>
    </StyledLayer>
};

export default SwipeUp;